import moment from "moment";
import { useContext } from "react";
import i18n from "i18n/i18n";
import { NotificationType } from "assets";

// Retrieve current progress status
export function getProgressStatus(notification: any, lang: string) {
  /*
   * Context, Props, Global Functions
   */

  let created = moment(notification.created);
  // either get date of progress started or date of now if no progress is made
  let progressstarted =
    notification.progressstarted > 0
      ? moment(notification.progressstarted)
      : moment();

  // show time since issue is open and unresolved (status 0: open, status 1: in progress)
  if (notification.status < 2) {
    let timeUnsolved = progressstarted.diff(created);

    // if time longer than 48h, show time range as days
    if (timeUnsolved < 172800000) {
      timeUnsolved = progressstarted.diff(created, "hours");
      return timeUnsolved + "h " + i18n(lang)?.unresolved;
    } else {
      timeUnsolved = progressstarted.diff(created, "days");
      return (
        timeUnsolved + " " + i18n(lang)?.days + " " + i18n(lang)?.unresolved
      );
    }
  }
}

export function getReportConfigLastTime(timestamp: any, lang: string) {
  if(timestamp===0) return "";
  /*
   * Context, Props, Global Functions
   */

  let now = moment();
  let lastexecutedat = timestamp > 0 ? moment(timestamp) : moment();

  let time = now.diff(lastexecutedat);

  // if time longer than 48h, show time range as days
  if (time < 172800000) {
    time = now.diff(lastexecutedat, "hours");
    return time + "h ";
  } else {
    time = now.diff(lastexecutedat, "days");
    return time + " " + i18n(lang)?.days;
  }
}

// get related color/class of notifications
export function getTypeColor(type: any) {
  type = Number(type);
 

  // get color depending on type
  switch (type) {
    case 0:
      return "Red";
    case 2:
      return "MidGray";
    case 3:
    case 4:
    case 5:
      return "Gray";
    case 6:
      return "Lightblue";
    case 7:
      return "#039BE5";
    default:
      return "Gray";
  }

}

// check if notifications contain notification that indicates a malfunction (type 0)
export function hasMalfunction(notifications: any) {

  
  let borderColor = "#9E9E9E";
  if (notifications) {
    // TODO: define what means undisturbed? Is it really only code 0 or also code 1 ?
    const filter_notification = notifications.filter(
      (n: any) => +n?.notification?.type == 0 || 6 || 7 || 1
    );

    if (filter_notification.length > 0) {
      
      let hasStorung = filter_notification.filter(
        (n: any) => +n?.notification?.type == 0 
      );

      let hasWartung = filter_notification.filter(
        (n: any) => +n?.notification?.type == 6 
      );

      let hasSeven = filter_notification.filter(
        (n: any) => +n?.notification?.type == 7 
      );

      let hasNotiz = filter_notification.filter(
        (n: any) => +n?.notification?.type == 2
      );

        if(hasStorung.length){
          borderColor= "var(--status-storung)";
        }
        else if(hasWartung.length) {
          borderColor= "var(--status-wartung-light)";
        }
        else if(hasSeven.length){
          borderColor= "#FFD700";
        } 
        else if(hasNotiz.length){
          borderColor= "#9E9E9E";
        } 
    }
  }
  return borderColor;
}

// function to return notification date time in DD.MM.YYYY, HH:MM h
export function getNotificationDateTime(notification: any, lang: string) {
  const notificationTypeString = i18n(lang)?.notificationtype_from;
  const notificationType = NotificationType(Number(notification.type), lang);

  if (notificationTypeString !== undefined && notificationType !== undefined) {
    const appBarTitle = notificationTypeString.replace(
      "%notificationtype",
      notificationType
    );
    return (
      appBarTitle.replace(
        "%datetime",
        moment(notification.created).format("DD.MM.YY, HH:MM")
      ) + "h"
    );
  } else {
    return "";
  }
}

export function NotificationTypeUpdated(
  type: any,
  notification: any,
  lang: string
) {
  // geplant wartund needs to have label of hascategory .

  /* Notification Types */
  const notificationTypes = [
    {
      code: 0,
      value: "malfunction",
      label: i18n(lang)?.notificationtype_malfunction,
    },
    {
      code: 1,
      value: "abnormality",
      label: i18n(lang)?.notificationtype_abnormality,
    },
    { code: 2, value: "memo", label: i18n(lang)?.notificationtype_memo },
    { code: 3, value: "task", label: i18n(lang)?.notificationtype_task },
    {
      code: 4,
      value: "internal_message",
      label: i18n(lang)?.notificationtype_internal_message,
    },
    {
      code: 5,
      value: "manufacturer_message",
      label: i18n(lang)?.notificationtype_manufacturer_message,
    },
    {
      code: 6,
      value: "planned_maintenance",
      label: i18n(lang)?.notificationtype_planned_maintenance,
    },
    {
      code: 7,
      value: "maintenance",
      label: i18n(lang)?.notificationtype_maintenance,
    },
  ];

  let notificationTypeString = "";
  notificationTypes.map((notificationType) => {
    if (notificationType.code === Number(type)) {
      if (Number(type) === 6) {
        notificationTypeString = notification?.hasmaintenancetask
          ? notification?.hasmaintenancetask[0]?.maintenancetask?.hascategory[0]
              ?.maintenancecategory?.name?.[i18n(lang)?.language]
          : "";
      } else {
        notificationTypeString = notificationType.label;
      }
    }
  });
  return notificationTypeString;
}

export function GetNotificationBorderColor(type: any) {
  type = Number(type);
  

  // get color depending on type
  switch (type) {
    case 0:
      return "var(--status-storung)";
    case 2:
      return "#9E9E9E";
    case 3:
    case 4:
    case 5:
      return "#9E9E9E";
    case 6:
      return "var(--status-wartung-light)";
    case 7:
      return "#FFD700";
    default:
      return "#9E9E9E";
  }
}

export function getNotificationBorderColor(type: any) {
  let borderColors = [
    "#FF3D00",
    "#FFB300",
    "#AEAEAE",
    "#AEAEAE",
    "#AEAEAE",
    "#AEAEAE",
    "var(--status-wartung-light)",
    "#FFD700",
  ];
  return borderColors[type];
}
